var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGithub(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6666 33.9168V27.9505C24.7245 27.2154 24.6252 26.4764 24.3753 25.7826C24.1254 25.0889 23.7307 24.4562 23.2175 23.9268C28.0583 23.3872 33.1458 21.5526 33.1458 13.1351C33.1454 10.9827 32.3175 8.91281 30.8333 7.35388C31.5361 5.47074 31.4864 3.38925 30.6946 1.54179C30.6946 1.54179 28.8754 1.00221 24.6666 3.82346C21.1332 2.86581 17.4085 2.86581 13.875 3.82346C9.66623 1.00221 7.84706 1.54179 7.84706 1.54179C7.05523 3.38925 7.00554 5.47074 7.70831 7.35388C6.21309 8.92437 5.38429 11.013 5.39581 13.1814C5.39581 21.5372 10.4833 23.3718 15.3241 23.973C14.8169 24.4972 14.4258 25.1222 14.1761 25.8075C13.9264 26.4928 13.8238 27.223 13.875 27.9505V33.9168M13.875 29.2918C6.16665 31.6043 6.16665 25.4376 3.08331 24.6668L13.875 29.2918Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.00e3df077d9df32c33c338afecaf032d.svg";
export { ForwardRef as ReactComponent };